<div class="linear-bet-builder-pick-remove-column">
    <bs-digital-pick-remove-button [removeButtonStyle]="removeButtonStyle" (remove)="removePick()"></bs-digital-pick-remove-button>
</div>
<div class="linear-bet-builder-pick-content-column">
    <bs-linear-bet-builder-pick-display-header
        [pick]="pick"
        [betslipType]="betslipType"
        [oddsDisplayFormat]="oddsDisplayFormat"></bs-linear-bet-builder-pick-display-header>
    <bs-linear-bet-builder-pick-content [pick]="pick"></bs-linear-bet-builder-pick-content>

    <div class="linear-bet-builder-pick-summary">
        <bs-linear-bet-builder-pick-summary [pickId]="pick.id"></bs-linear-bet-builder-pick-summary>

        <div class="linear-bet-builder-pick-rewards">
            <bs-digital-token-summary-container [tokenContext]="tokenContext"></bs-digital-token-summary-container>
            <bs-reward-tokens-selector-container [tokenContext]="tokenContext"></bs-reward-tokens-selector-container>
        </div>
    </div>
</div>
<bs-linear-bet-builder-pick-errors class="bet-builder-bet-pick__errors-container" [pickId]="pick.id"></bs-linear-bet-builder-pick-errors>
